import { Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { faCog, faPowerOff } from '@fortawesome/pro-regular-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { WebSessionService } from '@reconcept-platform/shared/authentication';
import { type UserAvatar_User, UserAvatarComponent } from '@reconcept-platform/shared/ui/core/avatar';
import {
  DropdownMenuComponent,
  DropdownMenuItemComponent,
  DropdownMenuTriggerDirective,
} from '@reconcept-platform/shared/ui/web';

@Component({
  selector: 'rcp-account-menu',
  imports: [
    DropdownMenuComponent,
    DropdownMenuItemComponent,
    DropdownMenuTriggerDirective,
    UserAvatarComponent,
    RouterLink,
    TranslatePipe,
  ],
  template: `
    <rcp-dropdown-menu>
      <div *dropdownMenuTrigger class="account-menu-trigger">
        <rcp-user-avatar [user]="viewer()" size="medium"></rcp-user-avatar>
      </div>

      <rcp-dropdown-menu-item [icon]="faCog" routerLink="/account">
        {{ 'qz-settings-zm' | translate }}
      </rcp-dropdown-menu-item>

      <rcp-dropdown-menu-item [icon]="faPowerOff" (click)="logout()">
        {{ 'qz-log-out-zm' | translate }}
      </rcp-dropdown-menu-item>
    </rcp-dropdown-menu>
  `,
  styles: `
    .account-menu-trigger {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      height: var(--navbar-item-height);
      padding: 0 var(--spacing-xl);
    }
  `,
})
export class AccountMenuComponent {
  private readonly sessionService = inject(WebSessionService);

  readonly viewer = input.required<UserAvatar_User>();

  logout() {
    this.sessionService.logout();
  }

  protected readonly faCog = faCog;
  protected readonly faPowerOff = faPowerOff;
}
